import useIsMounted from "@shared/hooks/useIsMounted";

export default useIsMounted;
